export const DEFAULT_PLAYLIST = {
    limit: 'infinites',
    name: 'date',
    mode: 'complete',
    anticipation: 'unlimited',
    wellnessRequired: false,
    rpeRequired: false,
}

const ANTICIPATION_DAYS = {
    today: 0,
    three_days: 3,
    seven_days: 7,
}

export function anticipationLimitDays(playlist) {
    const value = playlist?.anticipation
    if (!value || value === 'unlimited') return null
    return ANTICIPATION_DAYS[value] ?? null
}

export function isRoutineUnlocked(playlist, routineDate, today) {
    const limit = anticipationLimitDays(playlist)
    if (limit === null) return true
    if (!routineDate || !today) return true
    const diff = Math.round((new Date(`${routineDate}T00:00:00`) - new Date(`${today}T00:00:00`)) / 86400000)
    return diff <= limit
}

export function routineUnlockDate(playlist, routineDate) {
    const limit = anticipationLimitDays(playlist)
    if (limit === null || !routineDate) return null
    const date = new Date(`${routineDate}T00:00:00`)
    date.setDate(date.getDate() - limit)
    return date
}
